import { Component, inject, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ContextService, getClassNames } from '@bcef/ia-shared';
import { TranslateService } from '@ngx-translate/core';
import classNames from 'classnames';

@Component({
  selector: 'ia-simulateur-epargne-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  imports: [RouterOutlet],
})
export class AppComponent {
  private readonly translate = inject(TranslateService);

  private readonly contextService = inject(ContextService);

  protected typologies: string;

  constructor() {
    this.translate.use(this.contextService.language);
    this.typologies = classNames(getClassNames(this.contextService.typology));
  }
}
